/**
 * Header submenu caret behaviour.
 *
 * The caret lives inside the parent menu link because header-menu.js finds a
 * submenu through the link's parentElement; wrapping or moving the link stops
 * the mega menu opening. Clicking the caret therefore followed the parent
 * link, which read as a page refresh when already on that page.
 *
 * This script only cancels that navigation. It must NOT dispatch synthetic
 * pointer events: header-menu.js keeps hover state in a private variable and
 * fake pointerenter/pointerleave events desync it from the browser's real
 * hover state, which kills hover until the pointer fully exits the nav.
 * Opening and closing stays 100% on Horizon's own hover handling.
 *
 * Capture-phase listener so the click is cancelled before the anchor acts.
 * Inline handlers are not used because the storefront CSP drops them.
 */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var caret = target.closest('.menu-list__link-caret');
      if (!caret) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
